<script>
import {createTextMaskInputElement} from 'text-mask-core';
import masks from './masks';

const validMasks = [
    'cep', 'cnae', 'cnpj', 'cpf', 'date', 'datetime', 'decimal',
    'digits', 'document', 'issn', 'landline', 'mobile', 'month-year',
    'phone', 'short-phone', 'time', 'year',
];

/**
 * @see https://github.com/text-mask/text-mask
 */
export default {
    name: 'MaskedInput',

    inheritAttrs: false,

    props: {
        value: {
            type: [String, Number],
            required: false,
            default: '',
        },
        mask: {
            type: String,
            required: true,
            validator: (mask) => validMasks.indexOf(mask) !== -1,
        },
    },

    watch: {
        value(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.updateValue(newValue);
            }
        },
    },

    mounted() {
        this.initMask();
    },

    methods: {
        createTextMaskInputElement,

        setTextMaskInputElement() {
            const options = masks[this.mask];

            this.textMaskInputElement = this.createTextMaskInputElement({
                inputElement: this.$refs.input,
                mask: options.mask,
                guide: options.guide || false,
                placeholderChar: options.placeholderChar || '',
                keepCharPositions: options.keepCharPositions || false,
                pipe: options.pipe || undefined,
                showMask: options.showMask || true,
            });
        },

        initMask() {
            this.setTextMaskInputElement();
            this.textMaskInputElement.update(this.value);
        },

        updateValue(value) {
            this.textMaskInputElement.update(value);
            this.$emit('input', this.$refs.input.value);
        },

        focus() {
            this.$refs.input.focus();
        },
    },

    render(createElement) {
        return createElement('input', {
            ref: 'input',
            attrs: {...this.$attrs, type: 'tel'},
            domProps: {value: this.value},
            on: Object.assign(
                {...this.$listeners},
                {input: (event) => this.updateValue(event.target.value)},
            ),
        });
    },
};
</script>
